import { t, formatDate } from "../core/i18n.js";
import { runtime } from "../core/runtime.js";
import { dateKey, fromKey } from "../core/model.js";
import { render } from "./views.js";
import { closeModal } from "./plans.js";
import { icon } from "./icons.js";

export function openDatePicker() {
  const host = document.getElementById("modal");
  let focused = new Date(runtime.selectedDate);
  let month = new Date(focused.getFullYear(), focused.getMonth(), 1, 12);
  const selected = dateKey(runtime.selectedDate);
  function draw(focusDay = false) {
    const start = new Date(month);
    start.setDate(1 - ((month.getDay() + 6) % 7));
    const days = Array.from({ length: 42 }, (_, i) => {
      const date = new Date(start);
      date.setDate(start.getDate() + i);
      return date;
    });
    host.innerHTML = `<div class="modal date-picker-modal"><div class="tool-modal-head"><div><span class="eyebrow">DAYX / ${t("Your schedule")}</span><h2>${t("Choose a date")}</h2></div><button class="iconbtn" data-close aria-label="${t("Close")}">${icon("close")}</button></div><div class="date-picker-heading"><button class="iconbtn" data-calendar-month="-1" aria-label="${t("Previous month")}">${icon("arrow")}</button><strong>${formatDate(month, { month: "long", year: "numeric" })}</strong><button class="iconbtn" data-calendar-month="1" aria-label="${t("Next month")}">${icon("arrow")}</button></div><div class="date-picker-weekdays">${["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => `<span>${t(day)}</span>`).join("")}</div><div class="date-picker-grid" role="group" aria-label="${t("Choose a date")}">${days.map((date) => `<button type="button" data-calendar-day="${dateKey(date)}" ${date.getMonth() !== month.getMonth() ? 'class="outside-month"' : ""} aria-label="${formatDate(date, { weekday: "long", day: "numeric", month: "long", year: "numeric" })}" aria-pressed="${dateKey(date) === selected}" ${dateKey(date) === dateKey(new Date()) ? 'aria-current="date"' : ""} tabindex="${dateKey(date) === dateKey(focused) ? 0 : -1}">${date.getDate()}</button>`).join("")}</div><div class="date-picker-footer"><span>${t("Open a day to view its plans.")}</span><button class="btn" data-calendar-today>${t("Today")}${icon("arrow")}</button></div></div>`;
    host.querySelectorAll("[data-calendar-month]").forEach(
      (button) =>
        (button.onclick = () => {
          month.setMonth(
            month.getMonth() + Number(button.dataset.calendarMonth),
          );
          focused = new Date(month);
          draw(true);
        }),
    );
    const choose = (date) => {
      runtime.selectedDate = date;
      closeModal();
      render();
    };
    host.querySelectorAll("[data-calendar-day]").forEach((button) => {
      button.onclick = () => choose(fromKey(button.dataset.calendarDay));
      button.onkeydown = (event) => {
        const delta = {
          ArrowLeft: -1,
          ArrowRight: 1,
          ArrowUp: -7,
          ArrowDown: 7,
        }[event.key];
        if (
          delta === undefined &&
          !["Home", "End", "PageUp", "PageDown"].includes(event.key)
        )
          return;
        event.preventDefault();
        focused = fromKey(button.dataset.calendarDay);
        if (delta !== undefined) focused.setDate(focused.getDate() + delta);
        else if (event.key === "Home" || event.key === "End")
          focused.setDate(
            focused.getDate() +
              (event.key === "Home"
                ? -(focused.getDay() + 6) % 7
                : 6 - ((focused.getDay() + 6) % 7)),
          );
        else {
          const day = focused.getDate();
          focused.setDate(1);
          focused.setMonth(
            focused.getMonth() + (event.key === "PageUp" ? -1 : 1),
          );
          focused.setDate(
            Math.min(
              day,
              new Date(
                focused.getFullYear(),
                focused.getMonth() + 1,
                0,
              ).getDate(),
            ),
          );
        }
        month = new Date(focused.getFullYear(), focused.getMonth(), 1, 12);
        draw(true);
      };
    });
    host.querySelector("[data-calendar-today]").onclick = () => {
      const today = new Date();
      today.setHours(12, 0, 0, 0);
      choose(today);
    };
    if (focusDay)
      requestAnimationFrame(() =>
        host.querySelector('[data-calendar-day][tabindex="0"]')?.focus(),
      );
  }
  draw();
  host.classList.add("show");
  requestAnimationFrame(() =>
    host.querySelector('[data-calendar-day][tabindex="0"]')?.focus(),
  );
}

export function bindDatePicker() {
  const button = document.getElementById("navDatePicker");
  button.insertAdjacentHTML("afterbegin", icon("today"));
  button.onclick = openDatePicker;
}
